import {
  ActionItemPriorityEnum,
  CreateActionItemInput,
  EntityTagInput,
  RelatedEntityTypeEnum,
  StatusCategoryEnum,
} from '@/types/schema';

export default function getInitialTask({
  userId,
  fileId,
  entity,
  entityId,
  parentId,
  statusId,
  status,
  category,
  order,
  priority,
  dueDate,
  labelCategoryId,
  tags,
}: {
  userId: string | string[];
  fileId?: string | null;
  entityId?: string;
  entity?: RelatedEntityTypeEnum;
  parentId?: string;
  statusId?: string | null;
  status?: string;
  category?: StatusCategoryEnum | null;
  order?: number;
  priority?: ActionItemPriorityEnum | null;
  dueDate?: string | null;
  labelCategoryId?: string | null;
  tags?: EntityTagInput[];
}): CreateActionItemInput {
  return {
    statusId,
    status,
    category,
    title: '',
    instruction: {
      text: '',
    },
    tags: tags as any, //DO LATER: write a common type for ActionItemFragment and CreateActionItemInput to handle this in AddOrEditTaskDialog
    dueDate,
    priority: priority ?? ActionItemPriorityEnum.NoPriority,
    fileId,
    assignedToIds: Array.isArray(userId) ? userId : [userId],
    entity:
      entityId && entity
        ? {
            entityId,
            entityType: entity,
          }
        : undefined,
    parentId,
    order,
    labelCategoryId,
  };
}
